app.directive('lineLoader', ["PATH", function (PATH) {
  return {
    restrict: 'E',
    templateUrl: PATH.assets + 'img/line-loader.svg',
  	replace: true
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/lineLoader/lineLoaderDirective.js